import { useMemo } from "react";
import { useTranslation } from "@/packages/utils";
import type { AuditStatus, AuditStatusConfig } from "@/packages/types";
import { getPaletteColor } from "@/lib/color-palettes";
import { AUDIT_STATUS_SLOT } from "./constants";

/**
 * Hook that returns translated audit status configurations.
 * Replaces the hardcoded AUDIT_STATUS_LABELS with i18n values.
 */
export function useAuditStatusLabels(): Record<AuditStatus, AuditStatusConfig> {
  const { t } = useTranslation(["audits"]);

  return useMemo((): Record<AuditStatus, AuditStatusConfig> => {
    function buildConfig(status: AuditStatus): AuditStatusConfig {
      const color = getPaletteColor("audit-status", AUDIT_STATUS_SLOT[status]);
      return {
        label: t(`audits:status.${status}`),
        dotColor: color,
        badgeBg: `${color}26`,
        badgeText: color,
        sortOrder: AUDIT_STATUS_SLOT[status],
      };
    }

    return {
      pending: buildConfig("pending"),
      in_progress: buildConfig("in_progress"),
      submitted: buildConfig("submitted"),
      approved: buildConfig("approved"),
      rejected: buildConfig("rejected"),
      archived: buildConfig("archived"),
    };
  }, [t]);
}
